import Swal from 'sweetalert2/dist/sweetalert2.js';
// import networkCheck from './networkCheck';

const showAlert = ({ title, message, icon = 'success', option = {} }) => {
  let options = {
    showCancelButton: false,
    customClass: {
      cancelButton: 'order-1',
      confirmButton: 'order-2',
      denyButton: 'order-3',
    },
    title,
    html: `<p>${message}</p>`,
    icon,
  };

  if (icon === 'wait') {
    options = {
      showCloseButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      title,
      html: `
        <p>${message}</p>
        <div class="">
          <div class="lds-dual-ring"></div>
        </div>
      `,
    };
  }

  options = Object.assign({}, options, option);

  const swal = Swal.fire(options);

  return swal;
};

export default showAlert;
